export const STORAGE_PAYMENT_KEY = 'Box:paymentType';
